import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { push } from "connected-react-router";
import { UsernameUniqueErrorType } from "components/UpdateUsername/types";
import { createActionDispatchers } from "utils/reduxHelpers";

export type State = {
  usernameUpdateErrorType: UsernameUniqueErrorType;
  submittingUsernameUpdate: boolean;
};

export const initialState: State = {
  usernameUpdateErrorType: null,
  submittingUsernameUpdate: false,
};

const slice = createSlice({
  name: "editUsername",
  initialState,
  reducers: {
    clearUsernameUpdateError(state: State) {
      state.usernameUpdateErrorType = null;
    },
    submitUsernameUpdate(
      state: State,
      action: PayloadAction<{ username: string }>
    ) {
      state.submittingUsernameUpdate = true;
      state.usernameUpdateErrorType = null;
    },
    afterSubmitUsernameUpdate(state: State) {
      state.submittingUsernameUpdate = false;
    },
    afterSubmitUsernameUpdateFailure(
      state: State,
      action: PayloadAction<UsernameUniqueErrorType>
    ) {
      state.submittingUsernameUpdate = false;
      state.usernameUpdateErrorType = action.payload;
    },
  },
});

/**
 * actions from slice to be exported for saga
 */
export const {
  clearUsernameUpdateError,
  submitUsernameUpdate,
  afterSubmitUsernameUpdate,
  afterSubmitUsernameUpdateFailure,
} = slice.actions;

/**
 * all actions for layout
 */
export const actionProps = createActionDispatchers(
  slice.actions,
  ["clearUsernameUpdateError", "submitUsernameUpdate"],
  {
    goToSecuritySettings: () => push("/dashboard/securitysettings"),
  }
);

export default slice.reducer;
